// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"937":"2b9a1eb9","965":"1c5b2a73"}[chunkId] + ".chunk.js";
};